// Mock data for videographer portfolio

export const portfolioData = {
  hero: {
    name: "Edon Stavileci",
    tagline: "Videographer & Video Editor",
    description: "Capturing life's most precious moments through the lens",
    ctaText: "View My Work"
  },
  about: {
    title: "About Me",
    description: "I create cinematic reels and high-impact edits that help brands, artists and events stand out on social media. From fast-paced aftermovies to creative commercial content, I focus on delivering visually powerful edits with cinematic storytelling, smooth transitions and modern visuals that capture attention instantly.",
    expertise: [
      "Reel Editing",
      "Aftermovies",
      "Commercial Content",
      "Social Media Videos",
      "Wedding Films",
      "Event Coverage"
    ],
    stats: [
      { number: "500+", label: "Projects Completed" },
      { number: "5+", label: "Years Experience" },
      { number: "100+", label: "Happy Clients" }
    ]
  },
  videos: [
    {
      id: 1,
      title: "Video Project 1",
      thumbnail: "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80",
      instagramUrl: "https://www.instagram.com/p/DZqDjV6iP_5/?igsh=MWU2NTE3emFpaGFvag==",
      description: "Watch on Instagram"
    },
    {
      id: 2,
      title: "Video Project 2",
      thumbnail: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=800&q=80",
      instagramUrl: "https://www.instagram.com/p/DWMyT9RCPpY/?igsh=MXAzbXVvbG92Ymg5dA==",
      description: "Watch on Instagram"
    },
    {
      id: 3,
      title: "Video Project 3",
      thumbnail: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=800&q=80",
      instagramUrl: "https://www.instagram.com/p/DVtvXZQCPvy/?igsh=M28wbm1wbnkzajl6",
      description: "Watch on Instagram"
    },
    {
      id: 4,
      title: "Video Project 4",
      thumbnail: "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=800&q=80",
      instagramUrl: "https://www.instagram.com/p/DVMLBCIiMjV/?igsh=MWZvNmR6Zm5iN256dw==",
      description: "Watch on Instagram"
    },
    {
      id: 5,
      title: "Video Project 5",
      thumbnail: "https://images.unsplash.com/photo-1536240478700-b869070f9279?w=800&q=80",
      instagramUrl: "https://www.instagram.com/reel/DTOTt78iOD5/?igsh=MTA1dmhjNnljcjVqMA==",
      description: "Watch on Instagram"
    },
    {
      id: 6,
      title: "Video Project 6",
      thumbnail: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=80",
      instagramUrl: "https://www.instagram.com/reel/DSqckb2CJVV/?igsh=MTZzem84aWJsMXc5aQ==",
      description: "Watch on Instagram"
    },
    {
      id: 7,
      title: "Video Project 7",
      thumbnail: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=800&q=80",
      instagramUrl: "https://www.instagram.com/reel/DRmNPU4COiU/?igsh=MXI3cnZ3aXpsdDV0bA==",
      description: "Watch on Instagram"
    },
    {
      id: 8,
      title: "Video Project 8",
      thumbnail: "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=800&q=80",
      instagramUrl: "https://www.instagram.com/reel/DRcoBZ7CKAY/?igsh=MXFtcG1rZ2Voem9yeg==",
      description: "Watch on Instagram"
    },
    {
      id: 9,
      title: "Video Project 9",
      thumbnail: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&q=80",
      instagramUrl: "https://www.instagram.com/reel/DQE9jIpDNk2/?igsh=MXhvejdvMnRxYnpycw==",
      description: "Watch on Instagram"
    }
  ],
  services: [
    {
      title: "Reel Editing",
      description: "Fast-paced, attention-grabbing short-form content optimized for social media engagement.",
      features: ["Instagram Reels", "TikTok Videos", "Short-form Content", "Viral Style Editing"]
    },
    {
      title: "Event Aftermovies",
      description: "Capture the energy and emotion of your events with cinematic aftermovie edits.",
      features: ["Concerts", "Festivals", "Nightlife", "Highlights"]
    },
    {
      title: "Commercial Content",
      description: "Professional brand videos and promotional content that drives engagement and sales.",
      features: ["Brand Promos", "Product Videos", "Social Media Ads", "Creative Campaigns"]
    },
    {
      title: "Cinematic Editing",
      description: "High-end post-production services to elevate your content with professional polish.",
      features: ["Color Grading", "Sound Design", "Motion Graphics", "VFX & Transitions"]
    }
  ],
  testimonials: [
    {
      name: "Arta Berisha",
      role: "Bride",
      text: "Edon captured our wedding beautifully! The video brought tears to our eyes. Highly recommend!",
      rating: 5
    },
    {
      name: "Driton Kelmendi",
      role: "CEO, TechStart",
      text: "Professional, creative, and delivered exactly what we needed for our brand video. Exceeded expectations!",
      rating: 5
    },
    {
      name: "Ardit Krasniqi",
      role: "Event Organizer",
      text: "Super professional editing and crazy cinematic quality. The reels and aftermovie turned out even better than we imagined.",
      rating: 5
    }
  ],
  contact: {
    email: "Edon.stavileci@icloud.com",
    phone: "+383 44 540 570",
    location: "Kosovo",
    socialMedia: {
      instagram: "https://www.instagram.com/edonstavileci_?igsh=M3VzcGtyZ28yYXdh&utm_source=qr",
      youtube: "https://www.youtube.com/@edonstavileci",
      vimeo: "https://vimeo.com/edonstavileci"
    }
  }
};

export const categories = ["All", "Wedding", "Corporate", "Music", "Commercial", "Event"];
